import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home } from 'lucide-react';

export const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-300">404</h1>
        <p className="text-xl text-gray-600 mt-4">{t('errors.notFound')}</p>
        <Link
          to="/dashboard"
          className="btn-primary inline-flex items-center mt-6"
        >
          <Home className="w-5 h-5 mr-2" />
          {t('errors.backToHome')}
        </Link>
      </div>
    </div>
  );
};
